module.exports = __webpack_public_path__ + "img/icon_1.97a7fdfc.png";